import * as types from 'reducer/actionTypes';
import SettingService from 'components/setting/SettingService';
import SettingMongoDB from 'components/setting/SettingMongoDB';
import SettingRedis from 'components/setting/SettingRedis';
import SettingAdditional from 'components/setting/SettingAdditional';
import SettingUICustomization from 'components/setting/SettingUICustomization';
import SettingWebFont from 'components/setting/SettingWebFont';

const initialState = {
	tabs: [
		{
			tabId: "settingServices",
			tabName: "setting.service",
			component: SettingService
		},
		{
			tabId: "settingMongoDB",
			tabName: "setting.mongodb",
			component: SettingMongoDB
		},
		{
			tabId: "settingRedis",
			tabName: "setting.redis",
			component: SettingRedis
		},
		{
			tabId: "settingAdditional",
			tabName: "setting.additional",
			component: SettingAdditional
		},
		{
			tabId: "settingUICustomization",
			tabName: "setting.uicustomization",
			component: SettingUICustomization
		},
		{
			tabId: "settingWebFont",
			tabName: "setting.webfont",
			component: SettingWebFont
		}
	],

	apps: [
		{
			key: "app.word",
			value: "WORD"
		},
		{
			key: "app.cell",
			value: "CELL"
		},
		{
			key: "app.show",
			value: "SHOW"
		}
	],

	displayAppNames: [
		{
			key: "app.word",
			value: "WORD"
		},
		{
			key: "app.cell",
			value: "SPREADSHEET"
		},
		{
			key: "app.show",
			value: "PRESENTATION"
		}
	],

	redisModes: [
		{
			key: "setting.redisMode.single",
			value: "none",
			nodes: null
		},
		{
			key: "setting.redisMode.cluster",
			value: "redisServerIsClusterMode",
			nodes: "redisClusterNodes"
		},
		{
			key: "setting.redisMode.sentinel",
			value: "redisServerIsSentinelMode",
			nodes: "redisSentinelNodes"
		}
	],

	settingHeaders: [
		{
			key: "setting.showAppHeaderEditor",
			value: "showAppHeaderEditor"
		},
		{
			key: "setting.showAppHeaderViewer",
			value: "showAppHeaderViewer"
		}
	],

	settingKey: {
		filterServerBrokerURI: {
			key: "setting.filterServerBrokerURI",
			value: "filterServerBrokerURI"
		},
		docServerURI: {
			key: "setting.docServerURI",
			value: "docServerURI"
		},
		docServerActionListenerURI: {
			key: "setting.docServerActionListenerURI",
			value: "docServerActionListenerURI"
		},
		mongodbHost: {
			key: "setting.mongodbHost",
			value: "mongodbHost"
		},
		mongodbAuth: {
			key: "setting.mongodbAuth",
			value: "mongodbAuth",
			keyList: [
				{
					key: "setting.mongodbDatabase",
					value: "mongodbDatabase"
				},
				{
					key: "setting.mongodbUsername",
					value: "mongodbUsername"
				},
				{
					key: "setting.mongodbPassword",
					value: "mongodbPassword"
				},
			]
		},
		mongodbGridFS: {
			key: "setting.mongodbGridFS",
			value: "mongodbGridFS",
			keyList: [
				{
					key: "setting.mongodbHostGridFS",
					value: "mongodbHostGridFS"
				},
				{
					key: "setting.mongodbDatabaseGridFS",
					value: "mongodbDatabaseGridFS"
				},
				{
					key: "setting.mongodbUsernameGridFS",
					value: "mongodbUsernameGridFS"
				},
				{
					key: "setting.mongodbPasswordGridFS",
					value: "mongodbPasswordGridFS"
				}
			]
		},
		redisAuth: {
			key: "setting.redisAuth",
			value: "redisAuth",
			keyList: [
				{
					key: "setting.redisHost",
					value: "redisHost"
				},
				{
					key: "setting.redisPassword",
					value: "redisPassword"
				}
			]
		},
		redisMode: {
			key: "setting.redisMode",
			value: "redisMode",
			keyList: [
				{
					key: "setting.redisServerIsSentinelMode",
					value: "redisServerIsSentinelMode"
				},
				{
					key: "setting.redisServerIsClusterMode",
					value: "redisServerIsClusterMode"
				},
				{
					key: "setting.redisSentinelNodes",
					value: "redisSentinelNodes"
				},
				{
					key: "setting.redisClusterNodes",
					value: "redisClusterNodes"
				}
			]
		},
		productName: {
			key: "setting.productName",
			value: "productName"
		},
		appName: {
			key: "setting.appName",
			value: "appName",
			keyList: [
				{
					key: "app.webword",
					value: "appName_WORD"
				},
				{
					key: "app.webcell",
					value: "appName_CELL"
				},
				{
					key: "app.webshow",
					value: "appName_SHOW"
				},
				{
					key: "app.webpdf",
					value: "appName_PDF"
				}
			]
		},
		appLogoImage: {
			key: "setting.appLogoImage",
			value: "appLogoImage",
			keyList: [
				{
					key: "app.webword",
					value: "appLogoImage_WORD"
				},
				{
					key: "app.webcell",
					value: "appLogoImage_CELL"
				},
				{
					key: "app.webshow",
					value: "appLogoImage_SHOW"
				},
				{
					key: "app.webpdf",
					value: "appLogoImage_PDF"
				}
			]
		},
		appFavicon: {
			key: "setting.appFaviconImage",
			value: "appFaviconImage",
			keyList: [
				{
					key: "app.webword",
					value: "appFaviconImage_WORD"
				},
				{
					key: "app.webcell",
					value: "appFaviconImage_CELL"
				},
				{
					key: "app.webshow",
					value: "appFaviconImage_SHOW"
				},
				{
					key: "app.webpdf",
					value: "appFaviconImage_PDF"
				}
			]
		},
		appHeader: {
			key: "setting.appHeader",
			value: "appHeader",
			keyList: [
				{
					key: "setting.showAppHeaderEditor",
					value: "showAppHeaderEditor"
				},
				{
					key: "setting.showAppHeaderViewer",
					value: "showAppHeaderViewer"
				}
			]
		},
	},

	/*
	SettingService
	*/

	settingData: {
		filterServerBrokerURI: {
			single: {},
			multi: {}
		},

		docServerURI: {
			single: {},
			multi: {}
		},

		docServerActionListenerURI: {
			single: {},
			multi: {}
		},
		mongodbHost: {
			single: {},
			multi: {}
		},
		mongodbAuth: {},
		mongodbGridFS: {},
		redisAuth: {},
		redisMode: {},
	},

	/*
	SettingAdditional
	*/
	additionalData: [
	],

	uiCustomizationData: {},

	/*
	WebFont
	*/
	webFontData: [],

	error: null
};

export default function setting(state = initialState, action) {
	switch (action.type) {
		//set
		case types.SET_SETTING_ADDITIONAL_DATA:
			return {
				...state,
				additionalData: action.value
			}
		// get
		case types.FETCH_GET_SETTING_DATA_INFO_SUCCESS:
			return {
				...state,
				settingData: {
					...state.settingData,
					[action.key]: action.value
				}
			}
		case types.FETCH_GET_SETTING_ADDITIONAL_DEFAULT_KEY_INFO_SUCCESS:
			const setAdditional = state.additionalData.map(data => {
				if (data._id === action.row._id) {
					return ({
						...action.row,
						key: action.key,
						value: action.value,
						dataType: action.dataType
					})
				} else {
					return ({
						...data
					})
				}

			})

			return {
				...state,
				additionalData: setAdditional
			}

		case types.FETCH_GET_SETTING_ADDTIONAL_LIST_SUCCESS:
			return {
				...state,
				additionalData: action.value
			}

		//ui customization
		case types.FETCH_GET_UI_CUSTOMIZATION_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			}
		case types.FETCH_GET_UI_CUSTOMIZATION_SUCCESS:
			return {
				...state,
				loading: false,
				uiCustomizationData: action.value, // 서버에서 가져온 데이터 저장
			}
		case types.FETCH_GET_UI_CUSTOMIZATION_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			}

		// webfont
		case types.FETCH_WEBFONT_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			}
		case types.FETCH_WEBFONT_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				webFontData: action.value,
			}
		case types.FETCH_WEBFONT_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			}
		case types.FETCH_WEBFONT_UPLOAD_SUCCESS:
		case types.FETCH_WEBFONT_DELETE_SUCCESS:
			return {
				...state,
				loading: false,
			}

		default:
			return state
	}
}